import { Box, type BoxProps, Typography } from '@mui/material';
import React from 'react';

export type NerdyTipProps = {
  content?: string;
  children?: React.ReactNode;
  wrapperProps?: BoxProps;
};

export function NerdyTip({ content, children }: NerdyTipProps) {
  if (!content && !children) {
    return null;
  }

  const Wrapper = content
    ? ({ children }: { children: React.ReactNode }) => (
        <Box sx={{ px: { md: 12, lg: 16 }, mb: 8 }} component="aside" aria-label="Nerdy Tip">
          {children}
        </Box>
      )
    : React.Fragment;

  return (
    <Wrapper>
      <Box
        sx={{
          bgcolor: 'yellows.lightest',
          borderTop: '4px solid',
          borderColor: 'primary.main',
          padding: { xs: 3, md: 4.5 },
        }}
        data-testid="page-nerdy-tip"
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            marginBottom: 1,
            gap: 2,
          }}
        >
          <Typography variant="textLargeBold">🤓</Typography>
          <Typography component="p" variant="textBold">
            Nerdy Tip
          </Typography>
        </Box>
        {typeof content === 'string' ? <Typography>{content}</Typography> : children}
      </Box>
    </Wrapper>
  );
}
